'use client';

import VerificationInput from 'react-verification-input';
import * as styles from './code-input.css';

export interface CodeInputProps {
  value: string;
  onChange: (v: string) => void;
  length: number;
}

export function CodeInput({ length, value, onChange }: CodeInputProps) {
  return (
    <VerificationInput
      length={length}
      value={value}
      onChange={onChange}
      autoFocus
      inputProps={{ autoComplete: 'one-time-code', inputMode: 'numeric' }}
      validChars="0-9"
      classNames={{
        container: styles.container,
        character: styles.character,
        characterFilled: styles.characterFilled,
        characterSelected: styles.characterSelected,
      }}
    />
  );
}
